import React, { useCallback } from 'react'
import ReactDOM from 'react-dom'
import { uniqueId } from 'lodash'

import { Toast } from '../components/Toast'

// eslint-disable-next-line no-unused-vars
import { IToast, IUseToast } from '../interfaces/toast'

export const useToast = (props: IUseToast) => {
  const render = useCallback((element: JSX.Element, id: string) => {
    try {
      ReactDOM.render(
        element,
        document.querySelector(`.toast-container[data-id=${id}]`)
      )
    } catch (error) {
      console.error('Render toast fail!')
    }
  }, [])

  const close = useCallback((id) => {
    const toastContainer = document.querySelector(
      `.toast-container[data-id=${id}]`
    )!

    toastContainer.querySelector('.toast')!.classList.remove('show')
    toastContainer.querySelector('.toast')!.classList.add('close')

    setTimeout(() => {
      document.querySelector('#root-toast')!.removeChild(toastContainer)
    }, 600)
  }, [])

  const create = useCallback((toast: IToast) => {
    const id = uniqueId('toast_')
    const node = document.createElement('div')
    node.setAttribute('class', 'toast-container')
    node.setAttribute('data-id', id)
    document.querySelector('#root-toast')!.prepend(node)

    if (props?.sound) {
      const soundEffect = new Audio(props?.sound)
      soundEffect.volume = 0.2
      soundEffect.play()
    }

    const timeout = props?.timeout || 2500

    render(
      <Toast {...{ variant: toast.variant || 'info', timeout, ...toast }} />,
      id
    )

    setTimeout(() => {
      close(id)
    }, timeout)
  }, [])

  const toast = useCallback((toast: IToast) => {
    create(toast)
  }, [])

  const info = useCallback(
    (title: string, message?: string, consoleMessage?: any) => {
      toast({ variant: 'info', title, message })
      console.log(consoleMessage)
    },
    []
  )

  const success = useCallback(
    (title: string, message?: string, consoleMessage?: any) => {
      toast({ variant: 'success', title, message })
      console.log(consoleMessage)
    },
    []
  )

  const warning = useCallback(
    (title: string, message?: string, consoleMessage?: any) => {
      toast({ variant: 'warning', title, message })
      console.warn(consoleMessage)
    },
    []
  )

  const error = useCallback(
    (title: string, message?: string, consoleMessage?: any) => {
      toast({ variant: 'error', title, message })
      console.error(consoleMessage)
    },
    []
  )

  return { toast, info, success, warning, error }
}
